
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18gnm_1jcdq_9",
  "tree": "awsui_tree_18gnm_1jcdq_46"
};
  